import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimeleft = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", width: "1em", height: "1em", ...props, children: _jsx("path", { d: "M2 6c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4Zm4.4-1.2v-1c0-.2-.2-.4-.4-.4s-.4.2-.4.4V6s0 .2.1.3l1.1 1.1s.2.1.4 0c.3 0 .3-.4.1-.6l-.9-.9V4.8Z", style: {
            fill: '#fff',
        }, "data-name": "\\u5716\\u5C64_1" }) }));
export default SvgTimeleft;
